<template>
    <header
        class="AdminHeader"
    >
        <div class="AdminHeaderContainer">
            <div class="AdminHeaderWrapper flex flex-1 row-stretch">
                <div class="headerLeft flex row-left-center">
                    <RouterLink
                        :to="{ name: 'Main' }"
                        class="Logo"
                    >
                        <img
                            v-if="logo"
                            :src="logo"
                            :alt="label"
                            height="35"
                        >
                        <WText
                            v-if="!logo"
                            tag="h1"
                            hidden
                        >
                            {{ label }}
                        </WText>
                    </RouterLink>

                    <ul
                        v-if="(normalizeNavbar || []).length"
                        class="Nav row-left-stretch ml-1"
                    >
                        <NavHeaderItems
                            v-for="(navItem, index) in normalizeNavbar"
                            :key="`navLink-${index}`"
                            v-bind="navItem"
                            class="NavItem"
                            horizontal
                        />
                    </ul>
                </div>

                <div class="headerRight flex row-center ml-2">
                    <WButton
                        v-if="permissions.imports"
                        iconLeft="user-check"
                        outline
                        @click="handleClickImportsValidation"
                    >
                        {{ $t('admin.navigation.imports.validations' ) }}
                    </WButton>
                    <WButton
                        v-if="permissions.imports"
                        iconLeft="upload-cloud"
                        class="ml-1"
                        outline
                        @click="handleClickImports"
                    >
                        {{ $t('admin.navigation.imports.default' ) }}
                    </WButton>
                    <Dropdown
                        v-if="normalizeMenu"
                        :options="normalizeMenu"
                        :iconSize="28"
                        direction="bottomLeft"
                        icon="menu"
                        class="ml-1"
                        @onClick="handleClickMenu"
                    />
                </div>
            </div>
        </div>
    </header>
</template>

<script>
import VueTypes from 'vue-types'
import { mapState } from 'vuex'
import { Dropdown } from '@/components'
import { userMixin, mediaQueryMixin } from '@/mixins'
import { NavHeaderItems } from '../Navigation'

export default {
    name: 'AdminHeader',
    components: {
        Dropdown,
        NavHeaderItems,
    },
    mixins: [userMixin, mediaQueryMixin],
    props: {
        label: VueTypes.string,
        logo: VueTypes.string,
        navbar: VueTypes.arrayOf(VueTypes.shape({
            to: VueTypes.shape({
                name: VueTypes.string,
            }).loose,
            label: VueTypes.string,
            icon: VueTypes.string,
            attrs: VueTypes.shape({
                hidden: VueTypes.bool,
            }).loose,
        }).loose),
        menu: VueTypes.arrayOf(VueTypes.shape({
            to: VueTypes.shape({
                name: VueTypes.string,
            }).loose,
            label: VueTypes.string,
            icon: VueTypes.string,
            attrs: VueTypes.shape({
                hidden: VueTypes.bool,
            }).loose,
        }).loose),
    },
    computed: {
        ...mapState({
            me: state => state.system.user,
        }),
        normalizeNavbar () {
            return this.navbar.map(({ icon, ...item }, index) => ({ ...item, key: `navbar-${index}` }))
        },
        normalizeMenu () {
            const isMobile = this.$mq.w <= this.$mq.lg.min
            const mobileMenu = isMobile
                ? this.normalizeNavbar
                    .reduce((acc, item) => ([...acc, ...(!item.children ? [item] : item.children)]), [])
                    .map((item, index) => ({ ...item, icon: 'folder', key: `navbar-${index}` }))
                : []
            const defaultMenu = this.menu
                .filter(item => (item.permissions || []).includes(this.me.role) || !item.permissions)
                .map((item, index) => ({
                    ...item,
                    style: !index && isMobile ? ['separator-top'] : item.style,
                }))

            return [
                ...mobileMenu,
                ...defaultMenu,
            ]
        },
    },
    methods: {
        handleClickMenu ({ to }) {
            if (to) this.$router.push(to)
        },
        handleClickImports () {
            // eslint-disable-next-line handle-callback-err
            this.$router.push({ name: 'AdminImports' }).catch((err) => {})
        },
        handleClickImportsValidation () {
            // eslint-disable-next-line handle-callback-err
            this.$router.push({ name: 'AdminImportsValidate' }).catch((err) => {})
        },
    },
}
</script>

<style scoped lang="scss">
.AdminHeader {
    position: relative;
    top: 0;
    right: 0;
    left: 0;
    box-sizing: border-box;
    height: $navbar-height;
    background-color: $black;
    border-bottom: solid 1px rgba($black, 0.3);
    z-index: $zindex-navbar;

    &Container {
        display: flex;
        align-items: center;
        height: 100%;
    }

    &Wrapper {
        padding: 0 20px;
        height: 100%;
    }

    .Nav {
        display: none;
        height: 100%;
        margin: 0;
        padding: 0;
        list-style: none;

        @media screen and (min-width: $lg) {
            display: flex;
        }
    }
}

// Estilos para botones en el header (outline con texto blanco)
.headerRight {
    ::v-deep .WButton {
        &.outline.primary {
            color: $white;
            background-color: transparent;
            border-color: $white;

            .Icon {
                color: $white;
            }

            &:hover,
            &:focus,
            &:active {
                background-color: rgba($white, 0.15);
                border-color: $white;
                color: $white !important;

                .Icon {
                    color: $white !important;
                }
            }
        }
    }

    // Estilos para el dropdown menu con icono primary
    ::v-deep .Dropdown {
        .Btn .WIcon {
            color: $primary;
        }
    }
}
</style>
